var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.me)?_c('div',{staticClass:"page-container"},[_c('KycForm',{on:{"emitResult":_vm.emitResult}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }